export function logisticsInventoryConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    showSummary: true,
    sumColumnList: [
    {
      name: "number",
      overHidden: true,
      type: "sum",
    },
    {
      name: "totalIncludingTax",
      overHidden: true,
      type: "sum",
    },
    {
      name: "totalExclusiveTax",
      overHidden: true,
      type: "sum",
    },
    ],
    column: [{
        label: "物品名称",
        prop: "leaseName",
        display: true,
        slot: true,
        rules: [{
          required: true,
          message: "请输入物品名称",
          trigger: "blur",
        }, ],
      },
      {
        label: "抵押或质押",
        prop: "isCollateral",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_collateral",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        hide: true,
        display: true,
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],
      },
      {
        label: "抵质押物类型",
        prop: "collateralType",
        display: true,
        hide: true,

      },
      {
        label: "型号规格",
        prop: "model",
        display: true,
      },
      {
        label: "数量",
        prop: "number",
        display: true,
      },
      {
        label: "发票号",
        prop: "invoiceNo",
        display: true,
      },
      {
        label: "购置时间",
        prop: "purchasingDate",
        type: "date",
        

        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
      },
      {
        label: "生产厂商或供应商",
        prop: "manufacturerName",
        display: true,
      },
      {
        label: "抵质押权人",
        prop: "collateralPowerPerson",
        display: true,
        hide: true,

      },
      {
        label: "抵押人",
        prop: "collateralPerson",
        display: true,
        hide: true,

      },
      {
        label: '原值总价(含税)(元）',
        prop: "totalIncludingTax",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: '原值总价(扣税)(元）',
        prop: "totalExclusiveTax",
        display: false,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: "备注",
        type: 'textarea',
        prop: "remarks",
        span: 24,
        hide:true

      }

    ]
  }
}
